import { getHTML } from "../../services/helper";
import "./StepperContent.scss";

interface IProps {
  content: {
    header: string;
    itemsList: {name?: string, value: string}[]
  };
}

const StepperContent: React.FC<IProps> = (props: IProps) => {
  return (
    <div className="title-section">
      <h2 className="mb-5" dangerouslySetInnerHTML={getHTML(props.content.header)}></h2>
      {
        props.content.itemsList.length > 0 &&
        props.content.itemsList.map((item, index) =>
            <div key={index} className="step-number d-flex mb-4">
                <span className={'text-white' + (item.name ? ' step-name' : '')}>{item.name ? item.name : (index + 1)}</span>
                <p className="my-auto">{item.value}</p>
            </div>
        )
      }
    </div>
  );
};

export default StepperContent;
